module.exports = __webpack_public_path__ + "img/TramInLeipzig.a4c96391.jpg";